
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"preserveAspectRatio":"none","overflow":"visible","width":"87.963","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg","display":"block"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 1h28.275c.826 0 1.615.34 2.182.94l6.132 6.494c.944 1 2.26 1.566 3.636 1.566h39.311a3 3 0 013 2.973l.427 47a3 3 0 01-3 3.027H4a3 3 0 01-3-3V4a3 3 0 013-3z","fill":"#4D4E51","stroke":"#939598","stroke-width":"2"}})])
          )
        }
      }
    